import React, { useState } from 'react';
import { useAdmin } from '../../context/AdminContext';
import { useToast } from '../../context/ToastContext';
import { 
  LogOut, 
  Music, 
  Users, 
  Settings, 
  Home,
  Menu,
  X
} from 'lucide-react';
import AdminNaats from './AdminNaats';
import AdminNaatKhawans from './AdminNaatKhawans';
import AdminSettings from './AdminSettings';
import './AdminDashboard.css';

type AdminView = 'naats' | 'naatkhawans' | 'settings';

const AdminDashboard: React.FC = () => {
  const [currentView, setCurrentView] = useState<AdminView>('naats');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { logout } = useAdmin();
  const { showToast } = useToast();

  const handleLogout = () => {
    logout();
    showToast('Logged out successfully', 'success');
  };

  const navigation = [
    { id: 'naats', label: 'Manage Naats', icon: Music },
    { id: 'naatkhawans', label: 'Manage NaatKhawans', icon: Users },
    { id: 'settings', label: 'Settings', icon: Settings },
  ];

  const renderContent = () => {
    switch (currentView) {
      case 'naats':
        return <AdminNaats />;
      case 'naatkhawans':
        return <AdminNaatKhawans />;
      case 'settings':
        return <AdminSettings />;
      default:
        return <AdminNaats />;
    }
  };

  return (
    <div className="admin-dashboard">
      {/* Mobile Header */}
      <div className="admin-mobile-header">
        <button 
          className="admin-mobile-menu-btn"
          onClick={() => setSidebarOpen(!sidebarOpen)}
        >
          {sidebarOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
        <h1 className="admin-mobile-title">Admin Panel</h1>
        <button 
          className="admin-mobile-logout-btn"
          onClick={handleLogout}
        >
          <LogOut size={20} />
        </button>
      </div>

      {/* Sidebar */}
      <div className={`admin-sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="admin-sidebar-header">
          <Home className="admin-logo-icon" size={24} />
          <h1 className="admin-logo-text">NaatCity Admin</h1>
        </div>

        <nav className="admin-nav">
          {navigation.map((item) => {
            const Icon = item.icon;
            return (
              <button
                key={item.id}
                className={`admin-nav-item ${currentView === item.id ? 'active' : ''}`}
                onClick={() => {
                  setCurrentView(item.id as AdminView);
                  setSidebarOpen(false);
                }}
              >
                <Icon size={20} />
                <span>{item.label}</span>
              </button>
            );
          })}
        </nav>

        <div className="admin-sidebar-footer">
          <button className="admin-logout-btn" onClick={handleLogout}>
            <LogOut size={20} />
            <span>Logout</span>
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="admin-main">
        <div className="admin-content">
          {renderContent()}
        </div>
      </div>

      {/* Mobile Sidebar Overlay */}
      {sidebarOpen && (
        <div 
          className="admin-sidebar-overlay"
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </div>
  );
};

export default AdminDashboard;